import library from "./library";
import brainHalf from "./components/brain--half";
import * as _ from 'lodash';
import shape from './components/shape';


const shuffle = list => list.sort(() => Math.random() - 0.5);


const getRandomKey = obj => {
  const keys = Object.keys(obj);
  return keys[keys.length * Math.random() << 0];
};

const getRandomProperty = obj => {
  return obj[getRandomKey(obj)];
};

const getRandomArrayValue = arr => {
  return arr[getRandomArrayIndex(arr)];
};

const getRandomArrayIndex = arr => {
  return arr.length * Math.random() << 0;
};


const arrayRemove = (arr, value) => {
  return arr.filter(function (ele) {
    return ele != value;
  });
}


const actions = {
  kills: 'is wrong for',
  feeds: 'is right for',
};

const actionsShort = {
  kills: 'wrong',
  feeds: 'right',
};


const stepData = '';

let elements = {
  brain: {
    l: {
      // shape: 'circle',
      text: 'substance',
    },
    r: {
      // shape: 'blot',
      text: 'sense'
    }
  },
  something: {
    // shape: 'pentagon',
    text: 'year',
  },
};

let laws = [
  {
    action: 'feeds',
    elements: [{ type: 'text', value: 'year' }, { type: 'text', value: 'substance' }],
  },
  {
    action: 'feeds',
    elements: [{ type: 'text', value: 'year' }, { type: 'text', value: 'sense' }],
  },
  {
    action: 'kills',
    elements: [{ type: 'text', value: 'year' }, { type: 'text', value: 'sense' }],
  },
];

let hideMindMapHeader = false;

if (stepData) {
  let data = JSON.parse(stepData);
  laws = data.laws;
  elements = data.elements;
  hideMindMapHeader = true;
}

let lawsStandard = laws;
let elementsStandard = elements;


const om = new Vue({
  el: '#js-om',

  components: {
    'brain--half': brainHalf,
    shape,
  },

  data: {
    subscription: window.subscription,
    step: 0,
    maxStep: window.score,
    words: {},
    shapesEnabled: false,
    displayBrainIcon: true,
    points: 0,
    elements,
    laws,
    ioctopus: true,
    platformPos: { x: 0, y: 0 },
    started: false,
    stopped: false,
    errors: {},
    stat: {
      time: null,
      enabled: null,
    },
    try_n: 1,
    scrollShadowLeft: false,
    scrollShadowRight: false,
    gameTime: 0,
    hideMindMapHeader,
    helpLeft: true,
    helpRight: true,
  },


  mounted() {

    if (this.stepData) {
      let data = JSON.parse(this.stepData);
      this.$set(this, 'laws', data.laws);
      this.$set(this, 'elements', data.elements);
    }



    this.updatePlatformPos();
    this.resetGameTime();
    window.addEventListener('resize', this.updatePlatformPos);
    
    let tryN = window.localStorage.getItem('om_try_n');
    if (tryN) {
      this.try_n = Number(tryN);
    }

    setTimeout(this.updateScrollShadows, 100);

    window.addEventListener('load', this.updateScrollShadows);
    window.addEventListener('scroll', this.updateScrollShadows);
    window.addEventListener('resize', this.updateScrollShadows);
  },


  /*
   ######   #######  ##     ## ########  ##     ## ######## ######## ########
  ##    ## ##     ## ###   ### ##     ## ##     ##    ##    ##       ##     ##
  ##       ##     ## #### #### ##     ## ##     ##    ##    ##       ##     ##
  ##       ##     ## ## ### ## ########  ##     ##    ##    ######   ##     ##
  ##       ##     ## ##     ## ##        ##     ##    ##    ##       ##     ##
  ##    ## ##     ## ##     ## ##        ##     ##    ##    ##       ##     ##
   ######   #######  ##     ## ##         #######     ##    ######## ########
  */
  computed: {

    lawsTexts() {
      let list = [];
      let exists = new Set();

      for (let law of this.laws) {
        let action = actions[law.action];
        let text = `${law.elements[0].value} ${action} ${law.elements[1].value}`;

        if (exists.has(text)) continue;
        exists.add(text)

        text = text.replace('<BR>', ' ')
        text = text.replace('<br>', ' ')

        list.push({
          text,
          error: this.hasSomethingValue(law.elements[0].value) && this.hasError(law.action, law.elements[1].value)
        });
      }

      // list = shuffle(list);

      return list;
    },


    lawsMapDataItems() {
      let items = [];

      const getIndexOfText = (list, text) => {
        for (let i in list) {
          let item = list[i];
          if (item.content.text === text) return i;
        }

        return list.push({
          content: { text },
          items: [],
        }) - 1;
      };

      for (let law of this.laws) {
        let value0 = law.elements[0].value;
        let value1 = actionsShort[law.action];
        let value2 = law.elements[1].value;
        
        let i0 = getIndexOfText(items, value0);

        let items1 = items[i0].items;
        let i1 = getIndexOfText(items1, value1);

        let items2 = items1[i1].items;
        let i2 = getIndexOfText(items2, value2);
      }

      for (let item of items) {
        item.side = -1;
      }

      console.log('lawsMapDataItems', items)

      return items;
    },


    mindmap() {
      // if (this.step === 0) return true;

      let mindmap = !!(this.step % 2);
      console.log('mindmap', mindmap)
      return mindmap;
    },


    m() {
      let value = Math.floor(this.gameTime / 60);
      // if (value < 10) {
      //   value = '0' + value;
      // }
      return value;
    },


    s() {
      let value = this.gameTime % 60;
      if (value < 10) {
        value = '0' + value;
      }
      return value;
    },

  },


  /*
  ##     ## ######## ######## ##     ##  #######  ########   ######
  ###   ### ##          ##    ##     ## ##     ## ##     ## ##    ##
  #### #### ##          ##    ##     ## ##     ## ##     ## ##
  ## ### ## ######      ##    ######### ##     ## ##     ##  ######
  ##     ## ##          ##    ##     ## ##     ## ##     ##       ##
  ##     ## ##          ##    ##     ## ##     ## ##     ## ##    ##
  ##     ## ########    ##    ##     ##  #######  ########   ######
  */
  methods: {

    resetGameTime() {
      if (window.location.host === 'localhost') {
        this.gameTime = 30;
        return;
      }

      this.gameTime = 3 * 60;
    },


    startGameTime() {
      this.stopGameTimer();
      this.gameTimer = setInterval(() => {
        this.gameTime--;
        
        if (!this.gameTime) {
          this.stopGameTimer();
          this.addError('time');
        }
      }, 1000);
    },


    stopGameTimer() {
      this.gameTimer && clearInterval(this.gameTimer);
    },


    makeStep() {
      this.$set(this, 'errors', {});
      
      this.stopped = false;

      if (!this.step) {
        this.$set(this, 'laws', lawsStandard);
        this.$set(this, 'elements', elementsStandard);
        return;
      }
      

      let shapes = _.cloneDeep(library.shapes);
      let texts = _.cloneDeep(library.texts);

      const getRandomShape = () => {
        return shapes.splice(getRandomArrayIndex(shapes), 1)[0];
      };

      const getRandomText = () => {
        return texts.splice(getRandomArrayIndex(texts), 1)[0];
      };

      const getRandomType = () => {
        if (!this.shapesEnabled) {
          return 'text';
        }

        if (Math.random() > .5) {
          return 'text';
        }
        else {
          return 'shape';
        }
      };

      const getRandomElement = type => {
        type = type || getRandomType();
        let value;

        if (type === 'shape') {
          value = getRandomShape();
        }
        else {
          value = getRandomText();
        }

        return {
          type,
          value,
        }
      };

      const getRandomAction = () => {
        if (Math.random() > .8) {
          return 'kills';
        }
        return 'feeds';
      }



      // Laws Lists
      let stepElements = {
        1: [],
        2: [],
      };


      // Random Lists
      this.shapesEnabled && stepElements[1].push(getRandomElement('shape'));
      this.shapesEnabled && stepElements[2].push(getRandomElement('shape'));
      stepElements[1].push(getRandomElement('text'));
      stepElements[2].push(getRandomElement('text'));

      while (stepElements[1].length < 3) {
        stepElements[1].push(getRandomElement());
        stepElements[2].push(getRandomElement());
      }


      // Get Random Step Element
      const getRandomStepElement = (listN, type) => {
        let arr = stepElements[listN];
        let element = {};

        do {
          let i = getRandomArrayIndex(arr);
          element = arr[i];
        }
        while (!element || type && element.type !== type);

        return element;
      };


      // Something
      let somethingSource = {
        // shape: getRandomShape(),
        text: getRandomStepElement(1, 'text').value,
      };
      if (this.shapesEnabled) {
        somethingSource.shape = getRandomStepElement(1, 'shape').value;
      }

      
      const getRandomElementFromSomething = () => {
        let type = getRandomKey(somethingSource);
        return {
          type,
          value: somethingSource[type],
        }
      }

      const getRandomElementFromLawsList = listN => {
        let i = getRandomArrayIndex(stepElements);
        return stepElements[i];
      };


      // TODO Тут сделать создание laws на основе того, что уже есть списки 1 и 2 штук stepElements


      const createRandomLaw = (action) => {
        action = action || getRandomAction();

        return {
          action,
          elements: [
            getRandomStepElement(1),
            getRandomStepElement(2)
          ]
        }
      };


      // Laws
      let laws = [];


      // Random Law
      const getRandomLaw = action => {
        let element;
        let i = 0;

        do {
          element = getRandomArrayValue(laws);
          i++;
        }
        while (i < 1000 && action && element.action !== action);

        return element;
      };


      laws.push(createRandomLaw());
      laws.push(createRandomLaw());
      laws.push(createRandomLaw());
      laws.push(createRandomLaw());
      laws[0].elements[0].value = laws[1].elements[0].value;
      laws.push({
        action: getRandomAction(),
        elements: [
          laws[0].elements[0],
          laws[1].elements[1],
        ]
      })


      let sourceLaw = getRandomLaw('feeds');
      console.log('sourceLaw', sourceLaw)
      somethingSource.text = sourceLaw.elements[0].value;


      // Остальные законы
      for (let i = 0; i < 10; i++) {
        let law = createRandomLaw();
        if (law.elements[0].value !== somethingSource.text) {
          laws.push(law);
        }
      }
      laws[laws.length - 1].elements[0] = laws[0].elements[0];
      // laws.push(createRandomLaw());
      // laws.push(createRandomLaw());
      // laws.push(createRandomLaw());
      // laws.push(createRandomLaw());
      // laws.push(createRandomLaw());
      // laws.push(createRandomLaw());

      console.log('laws', _.cloneDeep(laws))
      

      // Brain laws
      let lLaws = [];
      let rLaws = [];
      lLaws.push(laws[0]);
      rLaws.push(laws[1]);
      if (this.shapesEnabled) {
        lLaws.push(getRandomLaw());
        rLaws.push(getRandomLaw());
      }

      // TODO Это костыль
      // let lrLaws = lLaws.concat(rLaws);
      // do {
        
      // }
      
      // laws.push(createRandomLaw());
      // laws.push(createRandomLaw());
      // laws.push(createRandomLaw());
      // laws.push(createRandomLaw(false, false));
      // laws.push(createRandomLaw(false, false));
      // let lawsForSomething = lLaws.concat(rLaws);

      // let something = {};
      // do {
      //   let law = getRandomArrayValue(lawsForSomething);
      //   let element = law.elements[0];
      //   if (!something[element.type]) {
      //     something[element.type] = element.value;
      //   }
      // }
      // while (lawsForSomething.length);

      // Compute brain laws
      const getComputedElementsFromLaws = (laws, elementI) => {
        let ret = {};

        for (let law of laws) {
          let element = law.elements[elementI];
          if (!ret[element.type]) {
            ret[element.type] = element.value;
          }
        }
        return ret;
      };

      const getRandomElementFromLaws = (laws, elementI) => {
        let law = getRandomArrayValue(laws);
        return law.elements[elementI];
      };
      let l = getComputedElementsFromLaws(lLaws, 1);
      let r = getComputedElementsFromLaws(rLaws, 1);


      // Something
      const mergeToSomething = (a, b) => {
        let ret = {};

        const merge = x => {
          let element = x.elements[0];
          if (ret[element.type]) return;
          ret[element.type] = element.value;
        };

        merge(a);
        merge(b);
      };


      // let something = Math.random() > .5
      //   ? mergeToSomething(lLaws, rLaws)
      //   : mergeToSomething(rLaws, lLaws);
      let something = somethingSource;
      
      // laws = shuffle(laws);
      // laws = laws.filter(function (value, index, array) {
      //   return array.indexOf(value) === index;
      // });

      laws = shuffle(laws);

      console.log('stepData', JSON.stringify({
        laws,
        elements: {
          brain: {
            l,
            r,
          },

          something,
        }
      }));

      console.log('laws', laws);

      this.$set(this, 'laws', laws);


      this.$set(this, 'elements', {

        brain: {
          l,
          r,
        },

        something,

      });

      console.log('elements', _.cloneDeep(this.elements));

      // Updating Map
      this.ioctopus = false;
      this.$nextTick(() => this.ioctopus = true);
    },


    statTick() {
      if (this.stat.enabled) {
        let milliseconds = new Date().getTime() - this.stat.time.getTime();
        wdpro.ajax({
          action: 'om_step',
          step: this.step,
          try_n: this.try_n,
          milliseconds,
          mindmap: Number(this.mindmap),
          error: this.stopped ? 1 : 0,
        }, res => console.log('res', res));
      }

      this.stat.time = new Date();
      this.stat.enabled = true;
    },


    feed(sides = []) {

      if (!this.started) {
        this.startGameTime();
      }

      this.started = true;

      // console.log('feeds', sides)

      // Unfeeds
      let unfeeds = [];

      // Checking
      const pressedValues = [];
      const tryToAddSideToPressedValues = side => {
        if (sides.indexOf(side) === -1) return;
        let { shape, text } = this.elements.brain[side];
        if (shape) pressedValues.push(shape);
        if (text) {
          pressedValues.push(text);
          unfeeds.push(text);
        }
      };
      tryToAddSideToPressedValues('l');
      tryToAddSideToPressedValues('r');

      // console.log('pressedValues', pressedValues)

      // console.log('lawsMapDataItems', this.lawsMapDataItems)

      // console.error('laws', _.cloneDeep(this.laws));

      // Массивы
      let kills = [];
      let feeds = [];

      for (let law of this.laws) {
        if (this.hasSomethingValue(law.elements[0].value) && this.hasBrainValue(law.elements[1].value)) {
          
          if (law.action === 'feeds') {
            let value = law.elements[1].value;
            feeds.push(value);
            
            unfeeds = arrayRemove(unfeeds, value);
          }
          if (law.action === 'kills') {
            kills.push(law.elements[1].value);
          }
        }
      }

      for (let value of kills) {
        feeds = arrayRemove(feeds, value);
      }


      // Убил
      console.log('kills', kills)
      for (let pressedValue of pressedValues) {
        console.log('pressedValue', pressedValue)
        if (kills.indexOf(pressedValue) !== -1) {
          this.addError('kills', pressedValue);
          break;
        }
      }

      // Недокормил
      for (let feed of feeds) {
        if (pressedValues.indexOf(feed) === -1) {
          this.addError('feeds', feed);
        }
      }


      // Покормил несъедобным
      if (unfeeds.length) {
        for (let unfeed of unfeeds) {
          this.addError('unfeed', unfeed, []);
        }
      }


      // Stat
      this.statTick();
      

      // On Error
      if (this.stopped) {
        this.increaseTryN();
      }


      // Make next step
      if (!this.stopped) {
        this.step++;
        this.makeStep();
        if (this.maxStep < this.step) this.maxStep = this.step;

        wdpro.ajax({
          action: 'save_om_score',
          score: this.step,
        }, res => console.log('res', res));
      }
      
    },


    addError(action, value, obj = {}) {
      console.error(action, value);
      if (!this.errors[action]) this.$set(this.errors, action, obj);

      if (Array.isArray(this.errors[action])) {
        if (this.errors[action].indexOf(value) === -1) {
          this.errors[action].push(value);
        }
      }
      else {
        this.$set(this.errors[action], value, true);
      }

      this.stopped = true;
      this.stopGameTimer();
    },


    hasError(action, value) {
      return !!this.errors?.[action]?.[value];
    },


    hasSomethingValue(value) {
      return value === this.elements.something.text
        || this.elements.something.shape && value === this.elements.something.shape
    },


    hasBrainValue(value) {
      return this.elements.brain.l.shape === value
        || this.elements.brain.l.text === value
        || this.elements.brain.r.shape === value
        || this.elements.brain.r.text === value;
    },


    updatePlatformPos() {
      let container = this.$refs.r || this.$refs.l;
      let width = container.clientWidth;
      this.platformPos.x = +width / 2 + 40;
    },


    startAgain() {
      // this.started = false;
      this.step = 0;
      this.resetGameTime();
      this.startGameTime();
      this.makeStep();

      wdpro.ajax({
        action: 'add_om_tries',
      });
    },


    increaseTryN() {
      this.try_n++;
      window.localStorage.setItem('om_try_n', this.try_n);
    },


    onTouchStart() {
      window.slideMenu.disableTouch();
    },


    onTouchEnd() {
      window.slideMenu.enableTouch();
    },


    updateScrollShadows() {
      let left = this.$el.scrollLeft;
      if (left > 0) {
        this.scrollShadowLeft = true;
      }
      else {
        this.scrollShadowLeft = false;
      }

      console.log('om--structure', this.$refs.content.clientWidth)
      console.log('om--scroll', this.$el.clientWidth)
      console.log('left', left);
      let right = this.$refs.content.clientWidth - this.$el.clientWidth - left;
      console.log('right', right)
      if (right > 0) {
        this.scrollShadowRight = true;
      }
      else {
        this.scrollShadowRight = false;
      }
    }

  },


  template: /* html */`
  <div
    :class="['om--scroll', {
      'om--scroll--shadow-left': scrollShadowLeft,
      'om--scroll--shadow-right': scrollShadowRight,
    }]"
    @scroll="updateScrollShadows"
  >

    

    <div
      ref="content"
      :class="['om--structure', {
        'om--started': started && !stopped,
      }]"
      @touchstart="onTouchStart"
      @touchend="onTouchEnd"
    >
    
      <!-- Left -->
      <div class="om--l" ref="r">


        <!-- Start Help -->
        <div v-if="helpLeft" class="om--start-help--block om--start-help--left">
          <p>See the rules here.</p>
          <p>(Which change at every step)</p>
          <p class="center"><button @click="helpLeft = false">OK</button></p>
        </div>

        <!-- Карта -->
        <octopus-app
          v-if="mindmap"
          ref="octopus"
          :map-data="{
            items: [
              {
                geometry: {
                  pos: { x: 0, y: 0 },
                },
                content: { text: 'Laws' },
                colorIndex: {root: 0},
                items: lawsMapDataItems,
              }
            ],
            geometry: {
              zoom: .8,
              pos: platformPos,
            },
          }"
          :menubar-items="[]"
          file-name="om"
          :subscription="subscription"
          :editable="false"
          :sharing-enabled="false"
          :panel-main="false"
          :panel-icons="false"
          :panel-colors="false"
          :panel-themes="false"
          :freeze-panels="true"
          :menubar="false"
          :scrollable="false"
          :scripts-enabled="false"
          :freeze-pos="true"
          :computed-zoom="false"
        ></octopus-app>



        <!-- Текст -->
        <div v-if="!mindmap" class="om--text-rules">

          <h2>Current step laws</h2>

          <p v-for="item in lawsTexts" :class="{
            'om--text-error': item.error,
          }">{{ item.text }}</p>

          <p>---</p>
          <p class="om--text-rules--info">* There may be unnecessary laws and words.<br/>Your job is to sort this out and make the right choice.</p>

          <template v-if="errors.unfeed?.length">
            <p class="om--text-error">{{ elements.something.text }} is not right for {{ errors.unfeed.join(' and ') }}</p>
          </template>

        </div>
      </div>


      <!-- Center -->
      <div class="om--c">

        <!-- Start Help -->
        <div v-if="helpRight" class="om--start-help--block om--start-help--right">
          <p>Here, click on the arrows to make the right choice.</p>
          <p>(Apply the word in the centre to the left word, to the right word, to both, or discard)</p>
          <p class="center"><button @click="helpRight = false">OK</button></p>
        </div>

        <!-- Score -->
        <div class="om--step">
          <span>Score: {{ step }}</span>
          <div v-if="step !== maxStep">(Maximum: {{ maxStep }})</div>
        </div>


        <p v-if="!displayBrainIcon" class="om-label">brain</p>




        <!-- Game Over -->
        <div v-if="stopped" class="om--game-over--container">
          <h1 class="om--game-over">Game Over</h1>
          <p v-if="errors.time" class="om--text-error">Time's up</p>
          <p v-if="errors.time" class="om--text-thanks">Thanks!</p>

          <!-- Список ошибок -->
          <div v-if="!errors.time">
            <template v-for="item in lawsTexts">
              <p v-if="item.error" :class="{
                'om--text-error': item.error,
              }">{{ item.text }}</p>
            </template>

            <template v-if="errors.unfeed?.length">
              <p class="om--text-error">{{ elements.something.text }} is not right for {{ errors.unfeed.join(' and ') }}</p>
            </template>
          </div>
        </div>


        <!-- Brain -->
        <div v-if="true || !stopped" :class="['brain', {
          'om--blured-on-stop': stopped,
        }]">
          <brain--half
            side="l"
            v-bind="elements.brain.l"
            :display-brain="displayBrainIcon"
          ></brain--half>
          <brain--half
            side="r"
            v-bind="elements.brain.r"
            :display-brain="displayBrainIcon"
          ></brain--half>
        </div>

        <!-- Start Again -->
        <div v-if="stopped" class="om--start-again"><button @click="startAgain()">Start again</button></div>

        <!-- Feed -->
        <div v-if="true || !stopped" :class="['om-label--container', {
          'om--blured-on-stop': stopped,
        }]">
          <div v-if="false && !started" class="om-label">apply</div>

          <div class="feed">
            <button class="feed-l" @click="feed(['l'])"></button>
            <button class="feed-t" @click="feed(['l', 'r'])"></button>
            <button class="feed-r" @click="feed(['r'])"></button>
          </div>
        </div>

        <!-- Something -->
        <div v-if="true || !stopped" :class="['something', {
          'om--blured-on-stop': stopped,
        }]">
          <div class="something--icon">
            <shape v-if="elements?.something?.shape" :shape="elements?.something?.shape"></shape>
          </div>
          <div class="something--text">{{ elements.something.text }}</div>
        </div>

        <!-- Drop -->
        <div v-if="true || !stopped" :class="['om-label--container', {
          'om--blured-on-stop': stopped,
        }]">
          <div v-if="false && !started" class="om-label">drop</div>
          <div class="drop">
            <button class="feed-b" @click="feed([])"></button>
            <i class="fas fa-trash-alt" style="font-size: 2em; color: #EEE;"></i>
          </div>
        </div>

      </div>


      <!-- Clock -->
      <div class="om--clock">
        <div>Game time: <h3 style="margin-top: 0; margin-bottom: 0;">{{m}}:{{s}}</h3></div>
      </div>
      
    </div>
  </div>
  `
})